export class PreviewConstant {
}
PreviewConstant.webAppDefaultTitle = "Untitled";
PreviewConstant.webAppDefaultSubTitle = "Welcome! This is a generative AI web app built in Imagica. Give it a try!";
